import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthenticatorServices from '../../services/AuthenticatorServices';

function PrivateRoute() {
    const token = localStorage.getItem('token');
    let isAuthenticated = false;
    if (token) {
        isAuthenticated = true;
    }
    //const isAuthenticated = AuthenticatorServices.isAuthenticated;

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />
}

export default PrivateRoute;


